module.exports = __webpack_public_path__ + "static/media/pharmacy_sinhala.5f473e34.jpg";